import api from './axiosInterceptor';
import { config } from '../config';

const API_URL = config.BACKEND_URL;

export const dataService = {
  getCountries: (agent = null) => {
    const params = agent ? { agent } : {};
    return api.get('/api/data/countries', { params });
  },
  getAgents: (country = null) => {
    const params = country ? { country } : {};
    return api.get('/api/data/agents', { params });
  },
  getUploaders: (country = null, agent = null) => {
    const params = {};
    if (country) params.country = country;
    if (agent) params.agent = agent;
    return api.get('/api/data/uploaders', { params });
  },
  searchByCountry: (country) => {
    return api.get(`/api/data/search/country/${encodeURIComponent(country)}`);
  },
  searchByAgent: (agent) => {
    return api.get(`/api/data/search/agent/${encodeURIComponent(agent)}`);
  },
  searchByUploader: (uploader) => {
    return api.get(`/api/data/search/uploader/${encodeURIComponent(uploader)}`);
  },
  searchCombined: (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.country) params.append('country', filters.country);
    if (filters.agent) params.append('agent', filters.agent);
    if (filters.uploader) params.append('uploader', filters.uploader);
    if (filters.status) params.append('status', filters.status);
    return api.get(`/api/data/search/combined?${params.toString()}`);
  },
  searchAll: (query) => {
    return api.get(`/api/data/search?q=${encodeURIComponent(query)}`);
  },
  getAllData: () => {
    return api.get('/api/data/all');
  },
  getExportAllData: () => {
    return api.get('/api/data/export-all');
  },
  uploadFile: (formData) => api.post('/api/upload/file', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }),
  updateAgent: (id, data) => {
    return api.put(`/api/data/update/${id}`, data);
  },
  deleteAgent: (id) => {
    return api.delete(`/api/data/delete/${id}`);
  },
  toggleFavorite: (id) => {
    return api.put(`/api/data/favorite/${id}`);
  },
  sendToQueue: (id, data) => {
    return api.put(`/api/data/queue/send/${id}`, data);
  },
  getPendingAgents: () => {
    return api.get('/api/data/queue/pending');
  },
  restoreFromQueue: (id) => {
    return api.put(`/api/data/queue/restore/${id}`);
  },
  getNotifications: (unreadOnly = false) => {
    return api.get(`/api/data/notifications${unreadOnly ? '?unreadOnly=true' : ''}`);
  },
  getUnreadCount: () => {
    return api.get('/api/data/notifications/unread-count');
  },
  markNotificationAsRead: (id) => {
    return api.put(`/api/data/notifications/${id}/read`);
  },
  markAllNotificationsAsRead: () => {
    return api.put('/api/data/notifications/read-all');
  },

  // Agent creation
  createAgent: (agentData) => {
    return api.post('/api/agents', agentData);
  },
  getAgentTemplate: () => {
    return api.get('/api/agents/template');
  },

  // Blacklist management
  getBlacklistAgents: (page = 1, limit = 50, search = '') => {
    const params = new URLSearchParams({ page, limit });
    if (search) params.append('search', search);
    return api.get(`/api/blacklist?${params.toString()}`);
  },
  getBlacklistStats: () => {
    return api.get('/api/blacklist/stats');
  },
  addToBlacklist: (agentData) => {
    return api.post('/api/blacklist', agentData);
  },
  moveToBlacklist: (id, sourceTable, blacklistReason) => {
    return api.put(`/api/blacklist/move/${id}`, { source_table: sourceTable, blacklist_reason: blacklistReason });
  },
  restoreFromBlacklist: (id) => {
    return api.put(`/api/blacklist/restore/${id}`);
  },
  updateBlacklistAgent: (id, agentData) => {
    return api.put(`/api/blacklist/${id}`, agentData);
  },
  deleteFromBlacklist: (id) => {
    return api.delete(`/api/blacklist/${id}`);
  },

  // Comments
  getComments: (agentId) => {
    return api.get(`/api/comments/${agentId}`);
  },
  addComment: (agentId, comment) => {
    return api.post(`/api/comments/${agentId}`, { comment });
  },
  toggleCommentReaction: (commentId, reaction) => {
    return api.post(`/api/comments/${commentId}/react`, { reaction });
  }
};
